export default {
	process: [],
	wolfApiProcess: {list:[]},
	loader: false,
  loaderList: false,
	error: false
}
	
